/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SetWochenplanInactive$Params {

/**
 * ID des Wochenplans der inaktiv gesetzt werden soll
 */
  wochenplanid: string;
}

export function setWochenplanInactive(http: HttpClient, rootUrl: string, params: SetWochenplanInactive$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setWochenplanInactive.PATH, 'delete');
  if (params) {
    rb.path('wochenplanid', params.wochenplanid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setWochenplanInactive.PATH = '/v1/wochenplaene/{wochenplanid}';
